import { render, staticRenderFns } from "./CreateProductButton.vue?vue&type=template&id=7387aa0f&"
import script from "./CreateProductButton.vue?vue&type=script&lang=ts&"
export * from "./CreateProductButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports